export enum ProfileTypes {
  GET_PROFILE = "GET_PROFILE",
}

export interface IGetProfileRequestAction {
  type: typeof ProfileTypes.GET_PROFILE;
}

export type ProfileActions = IGetProfileRequestAction;
